import { createContext, useContext, useState } from 'react';
import { getSelectedCityName, setSelectedCityName, clearSelectedCityName } from '../utils/selectedCity';

const CityContext = createContext(null);

export const CityProvider = ({ children }) => {
    const [cityName, setCityNameState] = useState(() => getSelectedCityName());

    const setCityName = (name) => {
        setCityNameState(name);
        setSelectedCityName(name);
    };

    const clearCityName = () => {
        setCityNameState(null);
        clearSelectedCityName();
    };

    return (
        <CityContext.Provider value={{ cityName, setCityName, clearCityName }}>
            {children}
        </CityContext.Provider>
    );
};

export const useCity = () => useContext(CityContext);
